module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/irc-framework/node_modules/core-js/internals/iterators.js
// module id = TRqp
// module chunks = 0